import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorDisplayHeading: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading',
		defaultMessage: 'We couldn’t load intent templates',
		description: 'Title for the error state that is displayed when templates fail to load',
	},
	errorDisplayDescription: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description',
		defaultMessage: 'Wait a moment and then try reloading.',
		description: 'Description for the error state that is displayed when templates fail to load',
	},
	reloadNowButtonText: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text',
		defaultMessage: 'Reload',
		description:
			'The text on the button that is displayed then the templates fail to load but can be reloaded by clicking on the button',
	},
});
